import React, { Component } from 'react';
import * as axios from "axios/index";

import { Loading } from "./parts/Loading";
import lightbox  from "./LightBoxEnable";


function VertArticle(props) {
  let prizeNode = null;
  if(props.article.meta.prize){
    prizeNode = <span className='vert-news-prize'>{props.article.meta.prize}</span>;
  }

  let vertSong = null;
  if(props.article.meta.song !== ''){
    vertSong = (
      <div className="vert-song-wrapper clearfix">
        <div className='vert-song-label'>曲</div>
        <div className='vert-song' dangerouslySetInnerHTML={{__html: props.article.meta.song}}/>
      </div>
    )
  }

  return (
    <div className='vert-news'>
      <div className='vert-news-header'>
        <div className='vert-news-date'>{props.article.meta.date}</div>
        <div className='vert-news-title'>{props.article.title} {prizeNode}</div>
        <div className='vert-news-place'>{props.article.meta.place}</div>
      </div>
      {vertSong}
      <div className='vert-news-content' dangerouslySetInnerHTML={{__html: props.article.content}}/>
    </div>
  )
}

class VertPinPlageComp extends Component {
  constructor(props) {
    super(props);
    this.state = {articles: []};
  }

  loadVpp() {
    let articles = [];

    async function callApi(page) {
      const params = {
        'page': page,
        'filter[posts_per_page]': 10,
        'filter[category_name]': 'vpp'
      };

      const resp = await axios.get('//midori-frauen.com/wp-json/posts', {params: params});
      articles = articles.concat(resp.data);
      if (resp.data.length === 10) {
        return callApi.bind(this)(page + 1);
      } else {
        this.setState({articles: articles});
      }
    }
    callApi.bind(this)(1);
  }

  componentDidMount() {
    // TODO: Caching
    this.loadVpp()
  }

  render() {
    
    const VertArticlesNode = this.state.articles.map((article, i) => {
      return <VertArticle article={article} key={i}/>
    })
    
    return (
      <div className='content'>
        <div className='vert-title'>Vert Pin Plage</div>
        <div className="vert-desc">
          2008年８月に福島県郡山市にて開催された[第31回 全日本おかあさんコーラス全国大会]に
          神奈川県より出場の３つの合唱団湘南はまゆう、女声合唱団「松(SHO)」、緑フラウエンコール
          が共に松村努先生指導の合唱団であったことをきっかけに、約100名の女声合唱団Vert Pin Plage
          を結成致しました
        </div>
        {
          this.state.articles.length === 0
            ?
            <Loading/>
            :
            <div className="vert-news-list">{VertArticlesNode}</div>
        }
      </div>
    )
  }
}

export const VertPinPlage = lightbox(VertPinPlageComp);


// WEBPACK FOOTER //
// ./src/components/VertPinPlage.jsx